// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_SalvarOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /orcamentos/salvar_orcamento
 *
 * Returns the created orcamento_id after saving.
 * Original shape: {dados: {orcamento_id: 123}} (object, not primitive)
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orcamentos_SalvarOrcamentoResponseDados {
orcamento_id?: number
}

export type Orcamentos_SalvarOrcamentoResponse = ApiResponse<Orcamentos_SalvarOrcamentoResponseDados>;

registerResponseContract('Orcamentos_SalvarOrcamentoResponse', {
  orcamento_id: { type: 'number',  required: false },
})
